import { Transaction } from "@/model/data/cashFlow/Transaction";
import { AxiosResponse } from "axios";
import { PaginatedServiceResponseData } from "../PaginatedServiceResponseData";

export class GetTransactionListResData extends PaginatedServiceResponseData {
    public transactions: Transaction[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        this.paginatedTotalItems = obj.TotalTransactionsCount;
        if (obj.Transactions) {
            this.transactions = [];
            obj.Transactions.forEach((v) => {
                var t = new Transaction();
                t.parse(v);
                this.transactions.push(t);
            });
        }
    }
}
